<template>
	<div>
		<div class="d-flex align-center justify-end mb-2 mt-2 px-2">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="loadingList"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="client_crms_count"
				:loading-info="$store.state.crm.loadingConversations"
			/>
		</div>
    <v-data-table
			ref="table"
			:headers="headers"
			:items="client_crms"
			item-key="id"
			:loading="loadingList"
			:server-items-length="client_crms_count"
			:options.sync="options"
			loading-text="Cargando datos..."
			class="crm-table"
			:class="$vuetify.breakpoint.mobile ? '':'resizable'"
			disable-sort
			hide-default-footer
			@click:row="selectRow"
			:item-class="selectedRowClass"
			:footer-props="{
        itemsPerPageText: 'Filas por página'
			}"
    >
			<template v-slot:item.id="{ item }">
				<div>
					<div class="d-flex align-center">
						<p class="mb-1 mr-1 font-weight-bold">LP {{ item.project_line_info?.project_line?.number }}</p>
						<ProjectLineAssociationMenu :projectLineAssociations="item.associations" :btnClick="() => selectRow(item)"/>
					</div>
					<div class="d-flex align-center">
						<ProjectLineAssociationIcons :projectLineAssociations="item.associations" />
					</div>
				</div>
			</template>
      <template v-slot:item.date="{ item }">
				<p class="mb-0 caption">{{ item.created_at | toDate }}</p>
				<p class="mb-0 caption">{{ item.created_at | toHour }}</p>
      </template>
      <template v-slot:item.project="{ item }">
				<p class="mb-0 caption font-weight-bold">{{ item.project_info?.project_detail }}</p>
				<p class="mb-0 caption" v-if="item.project_info?.address?.address">{{ item.project_info?.address?.address}}</p>
				<p class="mb-0 caption" v-else>--</p>
      </template>
      <template v-slot:item.vt_date="{ item }">
				<div v-if="item.schedule?.vt_date">
					<p class="mb-0 caption">{{ item.schedule?.vt_date | toDate }}</p>
					<p class="mb-0 caption">{{ item.schedule?.vt_date | toHour }}</p>
				</div>
				<p class="mb-0 caption" v-else>--</p>
      </template>
      <template v-slot:item.unarchive="{ item }">
				<div v-if="item.report_budgets?.length">
					<v-btn
						text
						dark
						x-small
						color="black"
						class="mb-1"
						@click.stop="() => { selectRow(item); openReportDetail && openReportDetail(getLastReportBudget(item).id); }"
					>
						<div class="d-flex align-center justify-center">
							<p class="font-weight-bold mb-0">{{getLastReportBudgetSerial(item)}}</p>
							<v-icon class="ml-1" x-small color="warning">mdi-eye</v-icon>
						</div>
					</v-btn>

					<div class="d-flex justify-center align-center" v-if="getLastReportBudget(item)?.budget?.payment_order">
						<div>
							<v-chip
								:color="reportStatusColor(item)"
								label
								outlined
								x-small
								class="px-1 py-2"
							>
								<div class="d-flex align-center justify-space-between caption">
									<b>{{reportStatusText(item)}}</b>
								</div>
							</v-chip>
							<p class="mb-0 caption"><small>Fecha Pago: </small><b>{{ getLastReportBudget(item)?.budget?.payment_order?.payment_info?.payment_date | toDate }}</b></p>
						</div>
					</div>
					<v-tooltip bottom v-else>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								dark
								x-small
								color="success"
								class="mx-1 mb-2"
								@click.stop="() => { selectRow(item); startPaymentUnarchive(item); }"

								v-bind="attrs"
								v-on="on"
							>
								<div class="d-flex justify-center align-center">
									<v-icon small dark>mdi-credit-card-outline</v-icon>
									<p class="mb-0 ml-1">Pagar Desarchivo</p>
								</div>
							</v-btn>
						</template>
						<span>Pagar Desarchivo</span>
					</v-tooltip>
				</div>
				<div v-else>--</div>
			</template>
      <template v-slot:item.responsible="{ item }">
				<p class="mb-0 caption">{{ item.schedule?.user_schedule?.responsible?.profile?.name }} {{ item.schedule?.user_schedule?.responsible?.profile?.lastname }} {{ item.schedule?.user_schedule?.responsible?.profile?.second_lastname }}</p>
      </template>
      <template v-slot:item.status="{ item }">
				<v-chip
					class="mt-1"
					:color="vtStatus(item).color"
					x-small
					label
					dark
					v-if="vtStatus(item)"
				>
					<v-icon class="mr-1" x-small>mdi-email-outline</v-icon>
					{{vtStatus(item).text}}
				</v-chip>
      </template>

			<template v-slot:item.actions="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							class="mx-1"
							icon
							dark
							x-small
							color="primary"
							@click.stop="() => { selectRow(item); openCrmDetail(item.id); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-eye</v-icon>
						</v-btn>
					</template>
					<span>Ver Detalle</span>
				</v-tooltip>
			</template>
    </v-data-table>
		<div class="d-flex align-center justify-end mt-2 px-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="client_crms_count"
				:loading-info="loadingList"
			/>
		</div>
	</div>
</template>

<script>
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'
import ProjectLineAssociationIcons from '@/components/Views/Projects/Parts/ProjectLineAssociationIcons'
import budgetStatuses from '@/components/Helpers/Constants/budget.js'

export default {
	name: 'ClientsCrmList',
	components: {
		DataTablePagination,
		ProjectLineAssociationMenu,
		ProjectLineAssociationIcons
	},
	props: {
		openReportDetail: {
      type: Function,
      required: false
    },
		clientId: {
      type: Number,
      required: true
    },
		openCrmDetail: {
      type: Function,
      required: true
    }
	},
	computed: {
		loadingList() {
			return this.$store.state.crm.loadingClientCrm
		},
		client_crms() {
			return this.$store.state.crm.clientCrms
		},
		client_crms_count() {
			return this.$store.state.crm.clientCrmsCount
		},
		selected_crm() {
			return this.$route.query?.crm
		}
	},
	watch: {
    options: {
      handler() {
				this.getClientCRM()
      },
      deep: true,
    }
	},
	data: () => ({
		budgetStatuses,
		selectedRowItem: null,
		headers: [
			{ text: 'Línea de Proyecto', value: 'id', align: 'center', sortable: false },
			{ text: 'Proyecto', value: 'project', sortable: false },
			{ text: 'Fecha de Creación', value: 'date', width: '120px', align: 'center', sortable: false },
			{ text: 'Visita Técnica', value: 'vt_date', width: '120px', align: 'center', sortable: false },
			{ text: 'P. Desarchivo', value: 'unarchive', width: '140px', align: 'center', sortable: false },
			{ text: 'Profesional Encargado', value: 'responsible', align: 'center', sortable: false },
			{ text: 'Estado', value: 'status', align: 'center', sortable: false },
			{ text: 'Acciones', value: 'actions', align: 'center', sortable: false },
		],
		searchInput: null,
		options: {
			page: 1,
			itemsPerPage: 10,
			sortBy: [],
			sortDesc: [],
		},
	}),
	mounted(){
		this.getClientCRM()
		const crm_id = this.$route.query.crm
		if(crm_id){
			this.selectedRowItem = crm_id
			this.openCrmDetail(crm_id)
		}
		else{
			const selectedRow = JSON.parse(localStorage.getItem('selected_clients_crm_row'));
			if (selectedRow) {
				this.selectedRowItem = selectedRow
			}
		}
		eventBus.$on('reloadInformation', this._onReloadCrm)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this._onReloadCrm);
	},
	methods: {
		startPaymentUnarchive(item){
			const last = this.getLastReportBudget(item)
			if(last && last.budget?.id){
				const url = 'https://apiarq.insomnia.cl/report-budget-confirm?rb=' + last.budget?.id;
				window.open(url, '_blank').focus();
			}
		},
		getLastReportBudget(item){
			const sorted = [...item.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];
			return last
		},
		reportStatusText(report){
			const sorted = [...report.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];
			const reportStatus = last.last_status?.status
			return this.$options.filters.budgetStatus(reportStatus)
		},
		reportStatusColor(report){
			const sorted = [...report.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];
			const reportStatus = last.last_status?.status
			return this.$options.filters.budgetStatusColor(reportStatus)
		},
		getLastReportBudgetSerial(item) {
			if (!item.report_budgets || item.report_budgets.length === 0) {
				return null;
			}
			const sorted = [...item.report_budgets].sort((a, b) => b.id - a.id);
			const last = sorted[0];

			const serial = `${last.serial?.serial} - LP${item.project_line_info?.project_line?.number} - ${last.prefix?.prefix} ${last.report_index}`;

			return serial.trim();
		},
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_clients_crm_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		_onReloadCrm(){
			this.getClientCRM()
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.getClientCRM()
		},
		getRowClass(item) {
			return item.id == this.selected_crm ? 'custom-client-highlight-row' : '';
		},
		vtStatus(conversation){
			if(conversation.schedule && conversation.schedule.status == 2 && conversation.schedule.request_email.length > 0){
				return {
					text: 'Informe Enviado',
					color: 'success'
				}
			}
			else if(conversation.schedule){
				return {
					text: 'Informe Pendiente',
					color: 'warning'
				}
			}
			return null
		},
		async getClientCRM(){
			let data = {
				...this.options,
				client_id: this.clientId,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('crm/getClientCrms', data)
		}
	}
}
</script>

<style>
.custom-client-highlight-row {
  background-color: #e8e8e8 !important;
}
</style>